export default __webpack_public_path__ + "static/media/selfie.d61b0e24.jpg";